import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Grid,
  Card,
  Box,
  Typography,
  CardMedia,
  CardContent,
} from '@mui/material';
import { IQrEntry, ISingleQrOperations } from './constants';
import { truncateStyle } from '../productsV2/productListView/constants';
import { IconQr } from '../../../utils/icons';
import { QrMenuContainer } from './QrMenuContainer';

interface Props extends ISingleQrOperations {
  entry: IQrEntry;
}

export const SingleQrTableEntry: FC<Props> = (props) => {
  const { entry } = props;

  const navigate = useNavigate();
  const [hoverState, setHoverState] = useState<boolean>(false);

  const goToDetailsPage = () => navigate(`/qr/${entry.id}`);

  return (
    <Grid item xs={1}>
      <Card
        elevation={hoverState ? 10 : 0}
        onMouseOver={() => setHoverState(true)}
        onMouseLeave={() => setHoverState(false)}
        className="border border-border-token w-full cursor-pointer"
        onClick={goToDetailsPage}
      >
        <div className="px-4 py-3 flex flex-col align-start gap-3">
          <Box className="flex justify-between align-center gap-2">
            <Typography
              className="!text-md !font-bold text-text-1 hover:text-accent-text hover:underline"
              onClick={goToDetailsPage}
              sx={truncateStyle(1)}
            >
              {entry.name}
            </Typography>
            <QrMenuContainer {...props} />
          </Box>
          <Box className="relative">
            {entry.branded_image ? (
              <CardMedia
                component="img"
                image={entry.branded_image}
                alt=""
                className="rounded-lg border border-border-token h-[140px] !object-cover p-2"
              />
            ) : (
              <Box className="flex h-[140px] items-center justify-center bg-tint rounded-xl">
                <IconQr stroke="#A58450" size={28} />
              </Box>
            )}

            <Box className="absolute bottom-2 right-2 flex gap-3">
              <Typography
                className="bg-surface rounded-lg px-2"
                color="text.secondary"
              >
                {entry.deactivated ? 'Inactive' : 'Active'}
              </Typography>
            </Box>
          </Box>
          <CardContent className="!p-0 h-5">
            <Typography
              className="font-normal !text-sm"
              sx={truncateStyle(1)}
              color="text.secondary"
            >
              {entry.name}
            </Typography>
          </CardContent>
        </div>
      </Card>
    </Grid>
  );
};
